import DOMPurify from 'dompurify';
import { twMerge } from 'tailwind-merge';

import { RichTextPreviewProps } from './types';

const richTextStyles = [
  // Base styles (exclude headings so they use global styles)
  '[&_*:not(h1,h2,h3,h4,h5,h6)]:[font-size:inherit]',
  '[&_*:not(h1,h2,h3,h4,h5,h6)]:[line-height:inherit]',
  // Headings - nested elements inherit font-weight
  '[&_h1_*]:font-bold',
  '[&_h2_*]:font-bold',
  '[&_h3_*]:font-bold',
  '[&_h4_*]:font-bold',
  '[&_h5_*]:font-bold',
  '[&_h6_*]:font-bold',
  // Paragraphs
  '[&_p]:min-h-[22px]',
  // Text formatting
  '[&_strong]:font-bold',
  '[&_strong_*]:font-bold',
  '[&_b]:font-bold',
  '[&_b_*]:font-bold',
  // Links
  '[&_a]:bg-accent-gradient-primary-primary',
  '[&_a]:hover:bg-accent-gradient-primary-hover',
  '[&_a]:active:bg-accent-gradient-primary-active',
  '[&_a]:bg-clip-text',
  '[&_a]:text-transparent',
  // Mark inside links - reset to show text (link uses text-transparent for gradient)
  '[&_a_mark]:text-black!',
  // Lists - base
  '[&_ol]:pl-6',
  '[&_ul]:pl-6',
  // Ordered lists - nested styles
  '[&_ol]:list-decimal',
  '[&_ol_ol]:list-[lower-alpha]',
  '[&_ol_ol_ol]:list-[lower-roman]',
  '[&_ol_ol_ol_ol]:list-decimal',
  '[&_ol_ol_ol_ol_ol]:list-[lower-alpha]',
  '[&_ol_ol_ol_ol_ol_ol]:list-[lower-roman]',
  // Unordered lists - nested styles
  '[&_ul]:list-disc',
  '[&_ul_ul]:list-[circle]',
  '[&_ul_ul_ul]:list-[square]',
  '[&_ul_ul_ul_ul]:list-disc',
  '[&_ul_ul_ul_ul_ul]:list-[circle]',
  '[&_ul_ul_ul_ul_ul_ul]:list-[square]',
  // Images - inline-block to respect text-align from parent div
  '[&_img]:inline-block',
  '[&_img]:align-top',
].join(' ');

export const RichTextPreview = ({
  content,
  className,
}: RichTextPreviewProps) => {
  if (!content) return null;

  const sanitizedHtmlContent = DOMPurify.sanitize(content, {
    ADD_ATTR: ['target'],
  });

  return (
    <div
      className={twMerge(richTextStyles, className)}
      dangerouslySetInnerHTML={{ __html: sanitizedHtmlContent }}
    />
  );
};
